import { useState } from "react";
import { useInterval } from "usehooks-ts";

/**
 * Custom hook for auto-reloading functionality
 * Triggers a reload every 30 seconds
 * Based on useCurrentTime implementation from savor-cake project
 */
export const useAutoReload = () => {
  const [reloadTrigger, setReloadTrigger] = useState(0);

  useInterval(
    () => {
      setReloadTrigger((prev) => prev + 1);
    },
    1000 * 5 * 60
  ); // 5 minutes

  return reloadTrigger;
};
